import { Typography } from '@newulife/common';

export default function AddressFormat({ address, fullName }) {
  if (!address) return null;
  if (address.ADDRESS1) return <Address address={address} fullName={fullName} />;
  else return <SOAddress address={address} fullName={fullName} />;
}

function Address(props) {
  const { COUNTRY } = props.address;
  switch (COUNTRY) {
    case 'KR':
      return <KRTemplate {...props} />;
    default:
      return <DefaultTemplate {...props} />;
  }
}
function DefaultTemplate(props) {
  const { ADDRESS1, ADDRESS2, CITY, STATE, ZIP, COUNTRY } = props.address;
  const name = props.fullName;
  return (
    <>
      {name && (
        <div style={{ padding: '0.1rem 0.4rem 0.1rem 0', display: 'inline-block' }}>{name}</div>
      )}
      <AddressChunk data={[ADDRESS1]} />
      {ADDRESS2 && <AddressChunk data={[ADDRESS2]} />}
      <AddressChunk data={[CITY]} />
      <AddressChunk data={[STATE]} />
      <AddressChunk data={[ZIP]} />
      {COUNTRY && <AddressChunk data={[COUNTRY]} />}
    </>
  );
}
function KRTemplate(props) {
  const { ADDRESS1, ADDRESS2, CITY, STATE, ZIP } = props.address;
  const name = props.fullName;
  return (
    <>
      {name && (
        <Typography variant="body3" mb={0.5}>
          {name}
        </Typography>
      )}
      <AddressChunk data={[CITY, STATE, ADDRESS1]} />
      <AddressChunk data={[ADDRESS2]} />
      <AddressChunk data={[ZIP]} />
      <AddressChunk data={[ADDRESS2]} />
    </>
  );
}
function AddressChunk({ data }) {
  return (
    <div style={{ padding: '.1rem .4rem .1rem 0' }}>
      {data.map((data) => {
        if (!data) return null;
        return data;
      })}
    </div>
  );
}

export function SOAddress({ address, fullName }) {
  if (!address) return null;
  const {
    Address1: ADDRESS1,
    Address2: ADDRESS2,
    AdministrativeArea: STATE,
    Country: COUNTRY,
    Locality: CITY,
    PostalCode: ZIP,
  } = address;
  const _address = {
    ...address,
    ADDRESS1,
    ADDRESS2,
    CITY,
    STATE,
    COUNTRY,
    ZIP,
  };
  return <Address address={_address} fullName={fullName} />;
}
